import { apiFetch, apiJson } from "./api";

export type CivicCity = {
  id: string;
  name: string;
};

export const DEFAULT_CIVIC_CITIES: CivicCity[] = [
  { id: "nyc", name: "New York, NY" },
  { id: "baltimore", name: "Baltimore, MD" },
  { id: "louisville", name: "Louisville, KY" },
  { id: "philadelphia", name: "Philadelphia, PA" },
  { id: "chicago", name: "Chicago, IL" },
];

export async function fetchJson<T>(url: string, init?: RequestInit): Promise<T | null> {
  try {
    const response = await apiFetch(url, init);
    if (!response.ok) return null;

    const contentType = response.headers.get("content-type") || "";
    if (!contentType.includes("application/json")) return null;

    return (await response.json()) as T;
  } catch {
    return null;
  }
}

export async function loadCivicCities(): Promise<CivicCity[]> {
  try {
    const res = await apiJson<{ success?: boolean; data?: CivicCity[] }>("/api/civic-cities");
    if (res?.success && Array.isArray(res.data) && res.data.length > 0) {
      return res.data;
    }
  } catch {
    // fall through to defaults
  }
  return DEFAULT_CIVIC_CITIES;
}

export function getCivicCityName(cities: CivicCity[], cityId: string): string {
  return cities.find((city) => city.id === cityId)?.name ?? cityId;
}
